module.exports = __webpack_public_path__ + "static/media/dropdown.844a042d.svg";